import { render } from "./DataProductsViewer.vue?vue&type=template&id=6495b493&scoped=true"
import script from "./DataProductsViewer.vue?vue&type=script&lang=js"
export * from "./DataProductsViewer.vue?vue&type=script&lang=js"

import "./DataProductsViewer.vue?vue&type=style&index=0&id=6495b493&scoped=true&lang=css"

import exportComponent from "D:\\_2021\\项目管理系统\\TYH_office_automation\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6495b493"]])

export default __exports__